import React, { FC } from 'react';
import { AspectRatio } from '@fiverr-private/layout_components';
import { Link, Typography } from '@fiverr-private/typography';
import { sendBigQueryEvent, getGuideKeyFromUrl } from '../helpers/events/sendBigQueryEvent';
import { BQ_CLICKED_RELATED_GUIDE } from '../helpers/events/bigQueryEventTypes';
import { sendMixpanelEvent } from '../helpers/mixpanelEvents';
import { MIXPANEL_EVENT_TITLE } from '../helpers/constants';
import { GuideImage } from '../GuideImage';

interface GuideProps {
  title: string;
  articleLink: string;
  imageLink: string;
  imageAlt: string;
  index: number;
  sourcePageKey: string;
}

export const Guide: FC<GuideProps> = ({ title, articleLink, imageLink, imageAlt, index, sourcePageKey }) => {
  const guideKey = getGuideKeyFromUrl(articleLink);
  const position = index + 1;

  const handleGuideClick = () => {
    sendBigQueryEvent({
      eventName: BQ_CLICKED_RELATED_GUIDE,
      params: {
        sourcePageKey,
        guideKey,
        position,
      },
    });
    sendMixpanelEvent({
      eventName: MIXPANEL_EVENT_TITLE.CLICKED_GUIDE_LINK,
      categoryName: sourcePageKey,
      guideName: title,
      guideUrl: articleLink,
      guideLocation: position,
    });
  };

  return (
    <Link
      target="_blank"
      onClick={handleGuideClick}
      href={articleLink}
      rel="noreferrer"
      decoration="none"
      opacity={{
        hover: '0.8',
      }}
      transition="opacity 0.3s ease-in-out"
    >
      <AspectRatio ratio="1.33/1" marginBottom="4" position="relative" overflow="hidden">
        <GuideImage src={imageLink} alt={imageAlt} />
      </AspectRatio>
      <Typography
        color="grey_1100"
        as="h3"
        size={{
          default: 'h_xxs',
          sm: 'h_xs',
        }}
      >
        {title}
      </Typography>
    </Link>
  );
};
